import { Form, Select } from 'antd';
import Button from 'components/Button';
import DrawerComponent from 'components/Drawer';
import useAgronomistList from 'hooks/useAgronomistList';
import { useEffect } from 'react';
import { RizeUser } from 'types/common';
import useUpdateAssignAg from '../../hooks/useUpdateAssignAgMutation';

type EditReportingDrawerProps = {
  data?: RizeUser;
  open: boolean;
  onClose: () => void;
  onFinish: () => void;
};

const EditReportingDrawer = ({
  data,
  open,
  onClose,
  onFinish,
}: EditReportingDrawerProps) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
  }, [open, form]);

  const { agronomistFilterOptions } = useAgronomistList(data?.country, {
    role: 'sr',
    labelKey: 'email',
    valueKey: 'email',
  });

  const { mutate, isPending: isLoading } = useUpdateAssignAg({
    onFinish: onFinish,
  });

  const onSubmitForm = async (value: {
    reportingToUserEmailList: string[];
  }) => {
    if (!data?.email) return;
    mutate({
      email: data?.email,
      ...value,
    });
  };

  if (!data?.country) return null;

  return (
    <DrawerComponent
      title="Add Reporting to"
      open={open}
      onClose={onClose}
      content={
        <Form form={form} onFinish={onSubmitForm}>
          <Form.Item
            className="form-label"
            label="Reporting to"
            labelCol={{ span: 24 }}
            name="reportingToUserEmailList"
          >
            <Select
              mode="multiple"
              maxCount={1}
              options={agronomistFilterOptions}
              placeholder="Select direct report of Junior Agronomist"
              style={{ maxWidth: 500 }}
            />
          </Form.Item>

          <Form.Item>
            <Button
              className="w-100"
              type="primary"
              htmlType="submit"
              disabled={isLoading}
            >
              Assign Senior Agronomist
            </Button>
          </Form.Item>
        </Form>
      }
    />
  );
};

export default EditReportingDrawer;
